import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

interface Body {
  meetingId: string;
}

@Injectable({
  providedIn: 'root'
})
export class ZoomService {
  public body: Body;

  constructor(
    public http: HttpClient
  ) {
  }

  getMeeting(meetingId) {
    // this.http.post('https://us-central1-reha-webpage.cloudfunctions.net/zoom-zoomMeeting', {
    //   meetingId: meetingId
    // }).toPromise().then((data: any) => {
    //   if (data.join_url) {
    //     console.log(data.join_url)
    //   } else {
    //     console.log(data)
    //   }
    // }).catch((error) => {
    //   console.log(error)
    // })

    this.body = ({
      meetingId: meetingId
    })

    return this.http.post("https://us-central1-reha-webpage.cloudfunctions.net/zoom-zoomMeeting", this.body);

  }



  // getMeeting(sig) {
  //   let meetingId = '91413227786'

  //   let headers = new HttpHeaders().set('Content-Type', 'application/json');
  //   headers.set('Authorization', 'Bearer ' + sig);

  //   this.httpClient.get('https://api.zoom.us/v2/meetings/registrants' + meetingId, { headers }).toPromise().then((data: any) => {
  //     if (data.signature) {
  //       console.log(data.signature)
  //       this.getMeeting(data.signature)
  //     } else {
  //       console.log(data)
  //     }
  //   }).catch((error) => {
  //     console.log(error)
  //   })
  // }

}